<template>
  <div class="h-full flex flex-col">
    <div
      class="px-5 h-12 w-full flex bg-white border-b border-orange-lighter items-center text-black"
    >
      <AccessSM/>
    </div>
    <perfect-scrollbar class="h-full">
      <router-view class="px-5 pt-5bg-white border-l border-r"></router-view>
    </perfect-scrollbar>
  </div>
</template>

<script>
import AccessSM from "./AccessSM";
export default {
  name: "Access",
  components: { AccessSM }
};
</script>
